<template>
  <ul class="small-information-list">
    <li>
      <v-icon class="bullet-arrow">{{ icons.mdiArrowRight }}</v-icon
      >No email assigned yet
    </li>
  </ul>
</template>

<script>
  export default {
    name: 'NoEmailAssigned',
  };
</script>
